<template>
  <div class="aa-donate">
    <button @click.prevent="donate = !donate" class="aa-donate-trigger" title="Want to buy me a beer?">
      <span class="aa-emoji">🍺</span>
      Buy me a beer
    </button>
    <div class="aa-donate-addresses" v-show="donate">
      <p>BTC: 1NwC1SbWt3oTQ82fkisABWahfRwMzVsG18</p>
      <p>ETH: 0x8d1ae7a2f52c4c23a9a40a6525a59871459fe2b7</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'donate',
  data () {
    return {
      donate: false
    }
  }
}

</script>

<style lang="stylus" scoped>
  .aa-donate
    // margin 35px 0
    display flex
    align-items center
    flex-direction column
    opacity 0
    animation show .5s ease-in .6s
    animation-fill-mode forwards
    p
      margin-top 10px
    *
      font-size .92rem
  .aa-donate-trigger
    display block
    width 100%
    font-size 1.2rem
    cursor pointer
    background #fff
    border 3px solid #000
    border-radius 5px
    padding 5px 10px
  .aa-donate-addresses
    width 450px
    margin-top 20px
    @media screen and (max-width: 520px)
      width 100%
</style>
